import React from 'react';

const VerticalBar = () => {

  return (
    <svg width="1" height="25" viewBox="0 0 1 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="0.6" height="24" transform="translate(0 0.599976)" fill="#B6B6BA" />
    </svg>
  );
}

export default VerticalBar;